export const Types = {
    TRAVELLERS_LIST: "TRAVELLERS_LIST",
    TRAVELLERS_DATA_BYID: "TRAVELLERS_DATA_BYID",
    UPDATE_TRAVELLER_DATA: "UPDATE_TRAVELLER_DATA",

  };
  